import React from 'react'
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import { Translation } from '../features/translations/getTranslation'

//https://react-dropzone-uploader.js.org/docs/quick-start

export const Upload = (props) => {
    // specify upload params and url for your files
    const getUploadParams = () => {
        const headers = {}
        props.headers.forEach(x => headers[x.name] = x.value)
        return { url: props.url, headers }
    }

    // called every time a file's `status` changes
    const handleChangeStatus = ({ xhr, meta, file }, status) => {        
        if (status === "done") {
            //console.log(xhr, meta, file)
            var res = null
            if (xhr !== null && xhr.response !== null) res = JSON.parse(xhr.response)
            if (props.saveObj) props.saveObj({ file: res.fileName, extension: res.extension, url: meta.previewUrl })
        }
        if (status === "error_upload") {
            alert("Error uploading file");
        }
    }
    Dropzone.defaultProps.inputContent = Translation.t("DRAG_FILE_OR_CLICK_TO_BROWSE")

    return (
        <Dropzone
            getUploadParams={getUploadParams}
            onChangeStatus={handleChangeStatus}
            accept={props.accept ?? "image/jpg,image/png,image/jpeg,application/pdf"}
        />
    )
}

export default Upload